import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { TextFieldWithDropdown } from 'seagull';
import { positiveQuantityInputProps } from '~/constants';
import { utils } from '~/utils';
function toDropdownValue(value) {
    return {
        text: value.amount,
        option: value.type
    };
}
function toDiscountValue(value) {
    return {
        amount: value.text,
        type: value.option
    };
}
function formatMobileSummaryValue(value) {
    if (!value.amount) return '';
    return value.type === 'percent' ? "".concat(value.amount, "%") : utils.formatDollarAmount(value.amount);
}
function discountOptions(isBillInStages, isBundle) {
    return [
        {
            value: 'percent',
            label: '%'
        },
        {
            value: 'value',
            label: '$',
            disabled: !!(isBillInStages || isBundle),
            disabledReason: isBillInStages ? 'Must be a percentage when billing in stages' : isBundle ? 'Discount can only be applied as a percentage' : undefined
        }
    ];
}
export function DiscountTextField(props) {
    const { value, onChange, testId, isBillInStages, isBundle, validateInBottomSheet, mobile } = props, rest = _object_without_properties(props, [
        "value",
        "onChange",
        "testId",
        "isBillInStages",
        "isBundle",
        "validateInBottomSheet",
        "mobile"
    ]);
    return /*#__PURE__*/ _jsx(TextFieldWithDropdown, _object_spread_props(_object_spread({}, rest), {
        bi: {
            name: 'discount_amount'
        },
        options: discountOptions(isBillInStages, isBundle),
        value: toDropdownValue(value),
        onChange: (v)=>onChange(toDiscountValue(v)),
        testId: testId && "".concat(testId, "-amount"),
        deriveProps: (option)=>({
                isPercentage: option === 'percent',
                isMoney: option !== 'percent',
                inputProps: positiveQuantityInputProps
            }),
        validateInBottomSheet: validateInBottomSheet,
        mobile: _object_spread_props(_object_spread({}, mobile), {
            displayValue: formatMobileSummaryValue(value)
        })
    }));
}
